import { FC, HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import { TimelineSegment, TimelineSegmentProps } from './TimelineSegment';
import styles from './Timeline.module.scss';
import { OneOrMoreReactElements } from '../../types';

export type TimelineSubcomponents = {
  Segment: typeof TimelineSegment;
};

export type TimelineProps = HTMLAttributes<HTMLDivElement> & {
  fullWidth?: boolean;
  size?: TimelineSize;
};

export enum TimelineSize {
  Small = 'small',
  Large = 'large',
}

export const Timeline: FC<TimelineProps> & TimelineSubcomponents = ({
  children,
  className,
  fullWidth = false,
  size = TimelineSize.Small,
}) => {
  const classNames = joinClassNames(
    styles.timeline,
    styles[size as keyof typeof styles],
    fullWidth && styles.fullWidth,
    className
  );
  return <ul className={classNames}>{children}</ul>;
};

Timeline.Segment = TimelineSegment;
